import { render, staticRenderFns } from "./clientAuditors.vue?vue&type=template&id=6790f31a&scoped=true&"
import script from "./clientAuditors.vue?vue&type=script&lang=js&"
export * from "./clientAuditors.vue?vue&type=script&lang=js&"
import style0 from "./clientAuditors.vue?vue&type=style&index=0&id=6790f31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790f31a",
  null
  
)

export default component.exports